export type InvoiceDraftPreviewInput = {
  invoiceNumber?: string;
  invoiceDate: string;
  dueDate?: string;
  currencyCode: string;
  customerName?: string;
  customerEmail?: string;
  notes?: string;
  discountAmount: number;
  lines: Array<{
    lineDescription: string;
    quantity: number;
    unitPrice: number;
    taxAmount: number;
  }>;
  subtotal: number;
  tax: number;
  total: number;
};

function esc(value: string | undefined | null): string {
  if (!value) return '';
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function buildDraftInvoicePreviewHtml(input: InvoiceDraftPreviewInput): string {
  const lineRows = input.lines
    .filter((l) => l.lineDescription.trim())
    .map(
      (line) =>
        `<tr>
          <td>${esc(line.lineDescription)}</td>
          <td style="text-align:right">${line.quantity}</td>
          <td style="text-align:right">${line.unitPrice.toFixed(2)}</td>
          <td style="text-align:right">${line.taxAmount.toFixed(2)}</td>
          <td style="text-align:right">${(line.quantity * line.unitPrice + line.taxAmount).toFixed(2)}</td>
        </tr>`,
    )
    .join('');

  return `<!DOCTYPE html><html><head><meta charset="UTF-8"><link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap"><style>
    body{font-family:Roboto,sans-serif;margin:24px;color:#1e293b;max-width:720px}
    .header{display:flex;justify-content:space-between;border-bottom:2px solid #334155;padding-bottom:12px;margin-bottom:20px}
    table{width:100%;border-collapse:collapse;margin-top:12px}
    th,td{border:1px solid #cbd5e1;padding:8px;text-align:left}
    th{background:#f8fafc}
    .totals{margin-top:16px;text-align:right}
    .draft{color:#b45309;font-size:12px;margin-bottom:8px}
  </style></head><body>
  <p class="draft">Draft preview — not yet saved</p>
  <div class="header">
    <div><h2>Invoice</h2>
    ${input.customerName ? `<p><strong>Bill to:</strong> ${esc(input.customerName)}</p>` : ''}
    ${input.customerEmail ? `<p>${esc(input.customerEmail)}</p>` : ''}
    </div>
    <div>
      <p><strong>#</strong> ${esc(input.invoiceNumber) || 'Auto'}</p>
      <p><strong>Date:</strong> ${esc(input.invoiceDate)}</p>
      ${input.dueDate ? `<p><strong>Due:</strong> ${esc(input.dueDate)}</p>` : ''}
    </div>
  </div>
  <table>
    <thead><tr><th>Description</th><th>Qty</th><th>Unit</th><th>Tax</th><th>Amount</th></tr></thead>
    <tbody>${lineRows || '<tr><td colspan="5">No lines</td></tr>'}</tbody>
  </table>
  <div class="totals">
    <p>Subtotal: ${input.subtotal.toFixed(2)} ${esc(input.currencyCode)}</p>
    <p>Tax: ${input.tax.toFixed(2)}</p>
    ${input.discountAmount > 0 ? `<p>Discount: -${input.discountAmount.toFixed(2)}</p>` : ''}
    <p><strong>Total due: ${input.total.toFixed(2)} ${esc(input.currencyCode)}</strong></p>
  </div>
  ${input.notes ? `<p><em>Notes: ${esc(input.notes)}</em></p>` : ''}
  </body></html>`;
}
